import { useQuery } from "@tanstack/react-query";
import api from "../api";
import urls from "../urls";

function useCanAssessManagerSiteFinancially() {
  const {
    isLoading,
    error,
    data: currentUserCanAssessManagerSiteFinancially
  } = useQuery({
    queryKey: ["can-assess-manager-site-financially"],
    queryFn: () => fetchData(),
    refetchInterval: false,
    refetchOnWindowFocus: false
  });

  return {
    isLoading,
    error,
    currentUserCanAssessManagerSiteFinancially
  };
}

async function fetchData() {
  const response = await api.get<boolean>(
    urls.api.currentUserCanAssessManagerSiteFinancially()
  );
  return response.data;
}

export { useCanAssessManagerSiteFinancially };
